import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { configureRouteGuards } from 'src/app/configure-route-guards';

@Injectable({
  providedIn: 'root'
})
export class RouteGuardReconfigurationService {

  constructor(private router: Router) {}

  /**
   * Reconfigures all route guards after wasInvitedByClient is set
   * This removes IncompleteRegisterGuard from routes for invited users
   */
  async reconfigureGuardsForInvitedUser(): Promise<void> {
    // Get the current route configuration
    const routeConfig = this.router.config;
    
    // Reconfigure each route that has redirectWhenIncompleteRegister
    for (const route of routeConfig) {
      if ((route as any).redirectWhenIncompleteRegister) {
        // Reset canActivate to remove existing guards
        route.canActivate = [];
        
        // Reconfigure guards with the new wasInvitedByClient state
        await configureRouteGuards(route as any);
      }
    }
    
    // Reset the router configuration with updated guards
    this.router.resetConfig(routeConfig);
  }
}
